export const CATEGORY_NAME = "categoryName";
export const COMMUNITY_ID = "communityId";
export const DESCRIPTION = "description";
